import React from 'react';
import clsx from 'clsx';
import './index.scss';

const NormalCheckBoxInput = ({ value, onChange, checked, label, id, color }) => {
  return (
    <div className={clsx('NormalCheckBoxInput', 
    { lightGray: color === '0' },
    { blue: color === '1' },
    )}>
      <input
        className="A-NCI-input"
        id={id}
        type="checkbox"
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default NormalCheckBoxInput;